import { createStyles, Theme } from '@material-ui/core/styles';

import type { InlineButtonProps } from './InlineButton';

const styles = ({ colors, spacing, typography }: Theme) => createStyles({
  link: {
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
    color: colors.controls.buttonText.enabled.name,
    textDecoration: 'none',
    cursor: 'pointer',
    borderRadius: spacing(4),
    'button&': {
      border: 'none',
      background: 'none',
    },

    '& svg': {
      fill: colors.controls.buttonText.enabled.icon,
    },

    '&:hover': {
      color: colors.controls.buttonText.hovered.name,
      background: colors.controls.buttonText.hovered.fill,
      '& svg': {
        fill: colors.controls.buttonText.hovered.icon,
      },
    },
    '&:active': {
      color: colors.controls.buttonText.pressed.name,
      background: colors.controls.buttonText.pressed.fill,
      '& svg': {
        fill: colors.controls.buttonText.pressed.icon,
      },
    },
  },
  iconMarginLeft: {
    marginLeft: spacing(1),
  },
  iconMarginRight: {
    marginRight: spacing(1),
  },
  text: {
    ...typography.textSmall,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  title: (props: InlineButtonProps) => ({
    ...typography.accentRegular,
    ...(props.oneLine ? {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    } : {}),
  }),
  small: {
    padding: `${spacing(0.5)}px ${spacing(2)}px`,
    '& $title': {
      ...typography.accentTiny,
    },
  },
  medium: {
    padding: `${spacing(1)}px ${spacing(3)}px`,
    '& $title': {
      ...typography.accentSmall,
    },
  },
  large: {
    padding: `${spacing(2)}px ${spacing(3)}px`,
    '& $iconMarginLeft': {
      marginLeft: spacing(2),
    },
    '& $iconMarginRight': {
      marginRight: spacing(2),
    },
  },
  disabled: {
    color: colors.controls.buttonText.disabled.name,
    cursor: 'default',
    '& svg': {
      fill: colors.controls.buttonText.disabled.icon,
    },
    '&:hover': {
      color: colors.controls.buttonText.disabled.name,
      background: 'none',
      '& svg': {
        fill: colors.controls.buttonText.disabled.icon,
      },
    },
  },
});

export default styles;
